import React, { useEffect } from 'react'
import { navigate } from 'gatsby'

export default function IndexPage() {
  useEffect(() => {
    navigate('/query')
  }, [])
  return <></>
}
